import { ChartType } from './Actions';
import { UTCTimestamp } from 'lightweight-charts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { COUNTRY_TIMEZONE_MAP } from '@cmctechnology/webinvest-constants';

dayjs.extend(utc);
dayjs.extend(timezone);
export const SEPARATOR = `__`;
export const CHART_ITEM_SEPERATOR = '\r\n';
export const CHART_DETAIL_SEPERATOR = '|';
export const DEFAULT_TIMEZONE = COUNTRY_TIMEZONE_MAP.AU!;
export const UTC_TIMEZONE = 'Etc/UTC';

// Is able to extract chart type from param, useful for determining API to call.
export const getChartTypeFromParam = (key: string): ChartType => {
  const params = key.split(SEPARATOR);
  return params[0] as ChartType;
};

export const getTimeZoneFromParam = (key: string): string => {
  const params = key.split(SEPARATOR);
  return params[1];
};

// taken from @cmctechnology/webinvest-tradingview-charting/public/charting_library/dataFeedApi
export interface Bar {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export const transformProData = (ProChartData: string, timeZone: string): Bar[] => {
  const chartData = ProChartData.split(CHART_ITEM_SEPERATOR);
  const dataTimzone = timeZone === DEFAULT_TIMEZONE ? DEFAULT_TIMEZONE : UTC_TIMEZONE;

  return chartData.map((d) => {
    const [time, open, high, low, close, volume] = d.split(CHART_DETAIL_SEPERATOR);
    return {
      time: new Date(dayjs.tz(time, dataTimzone).format()).getTime() as UTCTimestamp,
      open: Number.parseFloat(open),
      high: Number.parseFloat(high),
      low: Number.parseFloat(low),
      close: Number.parseFloat(close),
      volume: Number.parseFloat(volume)
    };
  });
};

export const convertSimpleChartToLineData = (data: string[]) => {
  return data.map((d) => {
    const [time, value, volume] = d.split(CHART_DETAIL_SEPERATOR);
    return {
      time: new Date(`${time}Z`).getTime() / 1000,
      value: Number.parseFloat(value),
      volume: volume === undefined ? undefined : Number.parseFloat(volume)
    };
  });
};
